import React from "react";
import { Box, Typography, LinearProgress } from "@mui/material";
import { styled } from "@mui/system";
import { colors } from "../constants/colors";

const PlaybackContainer = styled(Box)({
  background: "#f0f0f0",
  borderRadius: "15px",
  padding: "15px",
  textAlign: "center",
  fontWeight: "bold",
  color: "#333",
  fontSize: "16px",
  marginBottom: "15px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
});

const ProfileCard = ({
  username,
  mobileNumber,
  playbackHours,
  liveHours,
  email,
  intercomHours,
}:any) => {
  const [playbackMax, playbackRemaining] = playbackHours.split(" / ").map((time:any) =>
    parseDurationToMinutes(time)
  );
  const [liveMax, liveRemaining] = liveHours.split(" / ").map((time:any) =>
    parseDurationToMinutes(time)
  );
  const [IntercomMax, intercomRemaining] = intercomHours.split(" / ").map((time:any) =>
    parseDurationToMinutes(time)
  );

  const playbackPercentage = ((playbackMax - playbackRemaining) / playbackMax) * 100;
  const livePercentage = ((liveMax - liveRemaining) / liveMax) * 100;
  const intercomPercentage = ((IntercomMax - intercomRemaining) / IntercomMax) * 100;

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "15px",
        padding: "30px",
        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
        width: "100%",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <Typography variant="h5" color="textPrimary" gutterBottom>
        Profile Details
      </Typography>

      <Typography variant="h6" color="textSecondary">
        Username
      </Typography>
      <Typography color="textPrimary" gutterBottom>
        {username}
      </Typography>

      {mobileNumber && (
        <>
          <Typography variant="h6" color="textSecondary">
            Mobile Number
          </Typography>
          <Typography color="textPrimary" gutterBottom>
            {mobileNumber}
          </Typography>
        </>
      )}
      {email && (
        <>
          <Typography variant="h6" color="textSecondary">
            Email
          </Typography>
          <Typography color="textPrimary" gutterBottom>
            {email}
          </Typography>
        </>
      )}

      <PlaybackContainer style={{ backgroundColor: colors.white }}>
        <Typography style={{ textAlign: 'left', paddingBottom: 10, color: colors.orange, fontWeight: "bold", fontSize: '15px' }}>
          Playback Time Used: {formatMinutes(playbackMax - playbackRemaining)} / {formatMinutes(playbackMax)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ flexGrow: 1 }}>
            <LinearProgress
              variant="determinate"
              value={playbackPercentage}
              sx={{ height: 22, borderRadius: 6, backgroundColor: colors.silver, "& .MuiLinearProgress-bar": { backgroundColor: "#f36d4d" } }}
            />
          </Box>
          <Typography variant="body2" sx={{ marginLeft: 2 }}>
            {Math.round(playbackPercentage)}%
          </Typography>
        </Box>
      </PlaybackContainer>

      <PlaybackContainer style={{ backgroundColor: colors.white }}>
        <Typography style={{ textAlign: 'left', paddingBottom: 10, color: colors.orange, fontWeight: "bold", fontSize: '15px' }}>
          Live Time Used: {formatMinutes(liveMax - liveRemaining)} / {formatMinutes(liveMax)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ flexGrow: 1 }}>
            <LinearProgress
              variant="determinate"
              value={livePercentage}
              sx={{ height: 22, borderRadius: 6, backgroundColor: colors.silver, "& .MuiLinearProgress-bar": { backgroundColor: "#f36d4d" } }}
            />
          </Box>
          <Typography variant="body2" sx={{ marginLeft: 2 }}>
            {Math.round(livePercentage)}%
          </Typography>
        </Box>
      </PlaybackContainer>
      <PlaybackContainer style={{ backgroundColor: colors.white }}>
        <Typography style={{ textAlign: 'left', paddingBottom: 10, color: colors.orange, fontWeight: "bold", fontSize: '15px' }}>
        Intercomm Remaining Duration: {formatMinutes(IntercomMax - intercomRemaining)} / {formatMinutes(IntercomMax)}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ flexGrow: 1 }}>
            <LinearProgress
              variant="determinate"
              value={intercomPercentage}
              sx={{ height: 22, borderRadius: 6, backgroundColor: colors.silver, "& .MuiLinearProgress-bar": { backgroundColor: "#f36d4d" } }}
            />
          </Box>
          <Typography variant="body2" sx={{ marginLeft: 2 }}>
            {Math.round(intercomPercentage)}%
          </Typography>
        </Box>
      </PlaybackContainer>
    </Box>
  );
};

const parseDurationToMinutes = (duration:any) => {
  const [hours, minutes] = duration.split(":").map(Number);
  return hours * 60 + minutes;
};

const formatMinutes = (minutes:any) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h ${m}m`;
};

export default ProfileCard;
